import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-253f3d3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "details-form__item" }
const _hoisted_6 = { class: "profile-creation-wizard__content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_step_mobile_header = _resolveComponent("step-mobile-header")!
  const _component_price_selection = _resolveComponent("price-selection")!
  const _component_step_actions = _resolveComponent("step-actions")!
  const _component_daily_rate_side = _resolveComponent("daily-rate-side")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_joy_progress_bar, { percentage: _ctx.progressPercentage }, null, 8, ["percentage"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_step_mobile_header, {
            "step-name": _ctx.stepName,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "onClick:previous"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_price_selection, {
              min: _ctx.priceSelectionMinValue,
              max: _ctx.priceSelectionMaxValue
            }, null, 8, ["min", "max"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_joy_progress_bar, {
            percentage: _ctx.progressPercentage,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(_component_step_actions, {
            "step-name": _ctx.stepName,
            "is-disabled-button-next": !_ctx.hasValidFieldPart,
            "onClick:next": _ctx.goNext,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "is-disabled-button-next", "onClick:next", "onClick:previous"])
        ])
      ]),
      _createVNode(_component_daily_rate_side)
    ])
  ]))
}